import { useQuery } from "@tanstack/react-query";
import { getTeamById, getTeamsByEvent } from "./teams.service";

const key = "jeep-rally-teams";

export const useGetTeamById = (teamId, options = {}) => {
  return useQuery({
    queryKey: [key, teamId],
    queryFn: () => getTeamById(teamId),
    enabled: Boolean(teamId) && options.enabled !== false,
    ...options,
  });
};

export const useGetTeamsByEvent = (eventId, params = {}, options = {}) => {
  const type = params?.type || "";
  const category = params?.category || params?.category_id || "";

  return useQuery({
    queryKey: [key, "event", eventId, type, category],
    queryFn: () => getTeamsByEvent(eventId, params),
    enabled: Boolean(eventId) && options.enabled !== false,
    ...options,
  });
};
